import { render, staticRenderFns } from "./sumlist.vue?vue&type=template&id=5792e93f&scoped=true"
import script from "./sumlist.vue?vue&type=script&lang=js"
export * from "./sumlist.vue?vue&type=script&lang=js"
import style0 from "./sumlist.vue?vue&type=style&index=0&id=5792e93f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5792e93f",
  null
  
)

export default component.exports